import { ReactNode } from "react";
import SelfCampaignBrandHeader from "./SelfCampaignBrandHeader";
import SelfCampaignSupportBar from "./SelfCampaignSupportBar";
import "./SelfCampaignPageLayout.scss";

type SelfCampaignPageLayoutVariant = "create" | "design" | "activate";

type SelfCampaignPageLayoutProps = {
  children: ReactNode;
  footer?: ReactNode;
  rootClassName?: string;
  variant: SelfCampaignPageLayoutVariant;
};

const SelfCampaignPageLayout: React.FC<SelfCampaignPageLayoutProps> = ({
  children,
  footer,
  rootClassName,
  variant,
}) => {
  const rootClasses = ["self-campaign-page-layout", rootClassName]
    .filter(Boolean)
    .join(" ");

  const mainClasses = [
    "self-campaign-page-layout__main",
    `self-campaign-page-layout__main--${variant}`,
  ].join(" ");

  return (
    <div className={rootClasses}>
      <SelfCampaignSupportBar />
      <SelfCampaignBrandHeader />
      <main className={mainClasses}>{children}</main>
      {footer}
    </div>
  );
};

export default SelfCampaignPageLayout;
